module.exports = __webpack_public_path__ + "static/media/close_circle.60751163.svg";